
import TradeContractView, {emptyTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import ErrorPanel from "@/components/molecules/ErrorPanel.vue";
import AppHeader from "@/components/atoms/AppHeader.vue";
import TradeContractFormatView from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import ContractProfileTemplateForm from "@/components/organisms/ContractProfileTemplateForm.vue";
import {defineComponent, PropType} from "vue";
import TradeContractBaseView from "@/components/pages/contract/TradeContract/TradeContractBaseView";
import {ContractProfile} from "@/store/modules/hcs/contractProfile/model";
import {Step} from "@/components/templates/StepperPageTemplate.vue";
import ErrorMessage from "@/components/molecules/ErrorMessage";

export default defineComponent({
  name: "ContractProfile",
  components: {
    ContractProfileTemplateForm,
    AppHeader,
    ErrorPanel,
  },
  props: {
    tradeContracts: {
      type: Array as PropType<TradeContractBaseView[]>,
      required: true
    },
    tradeContractIndex: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array as PropType<Step[]>,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  computed: {
    tradeContract(): TradeContractBaseView {
      return this.tradeContracts[this.tradeContractIndex - 1] ?? emptyTradeContractView();
    },
    isTradeContractFormatView() {
      return this.tradeContract instanceof TradeContractFormatView;
    },
    isTradeContractView() {
      return this.tradeContract instanceof TradeContractView;
    },
    contractProfiles(): ContractProfile[] {
      return this.tradeContract.contractProfiles;
    },
    errors(): ErrorMessage[] {
      const errors: ErrorMessage[] = [];
      if(this.contractProfiles.length === 0) {
        errors.push({
          level: 'warn',
          message: '契約文書・契約条項・契約事項のいずれか1つ以上が必要です。'
        });
      } else {
        errors.push({
          level: 'good',
          message: `${this.nextPageName}に進むことができます。`
        });
      }
      return errors;
    },
    nextPageName(): string {
      return this.steps[this.step + 1]?.label ?? '送信設定';
    },
  },
});
